import { Spinner } from '@schibsted-svp/react-ui';
import classnames from 'classnames/bind';
import { useListTagsQuery } from 'services/admin-bff-sdk';
import styles from './LoadableTagLabels.module.scss';

const cln = classnames.bind(styles);

interface LoadableTagLabelsProps {
    provider: string;
    ids: string[];
    className?: string;
}

export function LoadableTagLabels({ provider, ids, className }: LoadableTagLabelsProps) {
    const { data, isFetching, error } = useListTagsQuery({ provider, ids }, { skip: !ids.length });
    const hasError = Boolean(error);

    return (
        <div className={cln('tags', { error: hasError }, className)}>
            {hasError
                ? 'Tags cannot be fetched.'
                : data?.listTags.map((tag) => (
                      <span key={`tag:${tag.id}`} className={cln('tag')}>
                          {error ? 'error' : tag.title || tag.id}
                          {isFetching && <Spinner size="compact" />}
                      </span>
                  ))}
        </div>
    );
}
